import React from "react"
import { Box, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import InputDateField from "src/components/atom/InputDateField"
import { Dayjs } from "dayjs"
import CheckBoxGroupField from "src/components/atom/CheckBoxGroupField"
import { useLoginContext } from "src/hooks/useLoginContext"
import { useMediaQuery } from "react-responsive"

type Props = {
  fromDate: Dayjs | null
  handleFromDate: any
  toDate: Dayjs | null
  handleToDate: any
  areaID: number[]
  handleAreaID: any
  categories: number[]
  handleCategories: any
}

export const EventSearchItem = ({
  fromDate,
  toDate,
  areaID,
  categories,
  handleFromDate,
  handleToDate,
  handleAreaID,
  handleCategories,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.inbox" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  const { areas, eventCategories } = useLoginContext()

  return (
    <>
      {isTablet ? (
        <Box
          sx={{
            mt: "50px",
            mx: "0px",
            p: "10px 20px",
            bgcolor: "#F1F1F1",
          }}
        >
          <Typography.SubTitle
            className="notosans weight400"
            sx={{ mt: "0px" }}
            color="textPrimary"
            fontSize={14}
          >
            {t("search_by_date")}
          </Typography.SubTitle>
          <InputDateField date={fromDate} size={12} handleDate={handleFromDate} />
          <InputDateField date={toDate} size={12} handleDate={handleToDate} />
          <CheckBoxGroupField
            name={t("place")}
            nameSize={14}
            datas={areas}
            labelSize={14}
            labelStyle={{ fontWeight: "400", fontFamily: "Noto Sans JP !important" }}
            lineSpace={0.5}
            selected={areaID}
            handleSelected={handleAreaID}
            sx={{ mt: "20px" }}
          />
          <CheckBoxGroupField
            name={t("category")}
            nameSize={14}
            selected={categories}
            handleSelected={handleCategories}
            datas={eventCategories}
            labelSize={14}
            labelStyle={{ fontWeight: "400", fontFamily: "Noto Sans JP !important" }}
            lineSpace={0.5}
          />
        </Box>
      ) : (
        <>
          <Box>
            <Typography.SubTitle
              className="notosans weight400"
              sx={{ mt: "0px" }}
              color="textPrimary"
              fontSize={14}
            >
              {t("search_by_date")}
            </Typography.SubTitle>

            <InputDateField date={fromDate} size={12} handleDate={handleFromDate} />
            <InputDateField date={toDate} size={12} handleDate={handleToDate} />
            <CheckBoxGroupField
              name={t("place")}
              nameSize={14}
              datas={areas}
              labelSize={14}
              labelStyle={{
                fontWeight: "400",
                fontFamily: "Noto Sans JP !important",
                pt: "10px!important",
              }}
              lineSpace={0.5}
              selected={areaID}
              handleSelected={handleAreaID}
              alignHorizontal={!isTablet}
              lineBreak
              noValidation
            />
            <CheckBoxGroupField
              name={t("category")}
              nameSize={14}
              selected={categories}
              handleSelected={handleCategories}
              datas={eventCategories}
              labelSize={14}
              labelStyle={{
                fontWeight: "400",
                fontFamily: "Noto Sans JP !important",
              }}
              lineSpace={0.5}
              alignHorizontal={!isTablet}
              lineBreak
              noValidation
            />
          </Box>
        </>
      )}
    </>
  )
}
